import { AbstractControl, ValidatorFn, ValidationErrors, FormArray } from '@angular/forms';

export class AppValidators {
  static selectionRequired(control: FormArray): { [key: string]: string } {
    // 'checked' is a FormControll name which value is checked in this validator. Needed only one to be true.
    const errorMessageKey: string = 'Must be minimum one checked';

    if (!control.value) {
      return { mustBeCheckedError: errorMessageKey };
    }

    for (let i = 0; i < control.controls.length; i++) {
      if (!!control.controls[i].value.checked) {
        return null;
      }
    }

    return { mustBeCheckedError: errorMessageKey };
  }

  static hasOwnIdProperty(control: AbstractControl): ValidatorFn  {
    return function(): ValidationErrors {
      return control.value.id ? null : { nomatch: true };
    }
  }

  static identical(firstControl: AbstractControl): ValidatorFn {
    return function(secondControl: AbstractControl): ValidationErrors {
      if (firstControl.value === secondControl.value) {
        return null;
      }

      return {
        identical: false
      };
    };
  }

  static minDate(date: Date): ValidatorFn {
    return function(control: AbstractControl): ValidationErrors {
      if (
        control.value instanceof Date &&
        date < control.value
      ) {
        return null;
      }

      return  {
        minDate: {
          requiredDate: date,
          selectedDate: control.value
        }
      };
    };
  }

  static maxDate(date: Date): ValidatorFn {
    return function(control: AbstractControl): ValidationErrors {
      if (
        control.value instanceof Date &&
        date > control.value
      ) {
        return null;
      }

      return  {
        maxDate: {
          requiredDate: date,
          selectedDate: control.value
        }
      };
    };
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/custom-validators/app-validators.ts